import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from './ContactCTA.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export default function ContactCTA() {
  return (
    <section className={styles.contactCta}>
      <div className={styles.contactWatermark} aria-hidden="true">Contact Us</div>
      <motion.div
        className={styles.contactContent}
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <h2 className={styles.contactTitle}>
            Building a sustainable future today.
        </h2>
        <Link to="/contact#consultancy_form" className={styles.ctaBtn}>Contact Us</Link>
      </motion.div>
        <div>&nbsp;</div>
    </section>
  );
}
